export const getRouter = () => window.app.router
